import { DialogTitle } from '@headlessui/react';
import { GET_PARTNER_CONTACT_CATEGORIES } from '@retainerclub/admin-api';
import PropTypes from 'prop-types';
import {
  DynamicMultiSelect,
  EmailInput,
  Fieldset,
  Input,
  Modal,
  PhoneInput,
} from '../../shared';
import PartnerContactFormWrapper from './PartnerContactFormWrapper';

function PartnerContactModal({
  open,
  handleCloseModal,
  currentPartnerContact = null,
  partnerOrganizationId,
  partnerLocationId = null,
}) {
  return (
    <Modal open={open} setOpen={handleCloseModal} size="2xl">
      <div>
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-semibold text-2xl text-rcgray-900 capitalize leading-6"
          >
            {currentPartnerContact ? 'Update' : 'Add a New'} partner contact
          </DialogTitle>
        </div>
      </div>
      <div className="mt-4">
        <PartnerContactFormWrapper
          partnerContact={currentPartnerContact}
          handleCloseModal={handleCloseModal}
          partnerOrganizationId={partnerOrganizationId}
          partnerLocationId={partnerLocationId}
        >
          <div className="sm:col-span-6">
            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
              <Fieldset title="Contact Info" hideBorder>
                <Input
                  className="sm:col-span-3"
                  required
                  name="firstName"
                  label="First Name"
                />
                <Input
                  className="sm:col-span-3"
                  required
                  name="lastName"
                  label="Last Name"
                />
                <EmailInput
                  className="sm:col-span-3"
                  name="email"
                  label="Email"
                />
                <PhoneInput
                  className="sm:col-span-6 xl:col-span-3"
                  name="phone"
                  label="Phone"
                />
                <DynamicMultiSelect
                  name="partnerContactCategoryIds"
                  className="sm:col-span-full"
                  dynamicQuery={GET_PARTNER_CONTACT_CATEGORIES}
                  dataName="partnerContactCategories"
                  label="Contact Categories"
                  maxMenuHeight={180}
                />
              </Fieldset>
            </div>
          </div>
        </PartnerContactFormWrapper>
      </div>
    </Modal>
  );
}

PartnerContactModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  currentPartnerContact: PropTypes.object,
  partnerOrganizationId: PropTypes.string.isRequired,
  partnerLocationId: PropTypes.string,
};

export default PartnerContactModal;
